import { useEffect, useState } from "react";
import { Check, Loader2, Trash2 } from "lucide-react";
import { Button } from "~/components/ui/button";
import { Textarea } from "~/components/ui/textarea";
import { cn } from "~/lib/utils";

type SaveState = "idle" | "saving" | "saved";

interface SamplePromptRowProps {
  index: number;
  value: string;
  saveState: SaveState;
  disabled?: boolean;
  onChange: (value: string) => void;
  onDelete: () => void;
}

const SamplePromptRow = ({
  index,
  value,
  saveState,
  disabled,
  onChange,
  onDelete,
}: SamplePromptRowProps) => {
  const [showCheck, setShowCheck] = useState(false);

  useEffect(() => {
    if (saveState === "saved") {
      setShowCheck(true);
      const timer = setTimeout(() => setShowCheck(false), 2000);
      return () => clearTimeout(timer);
    }
    setShowCheck(false);
  }, [saveState]);

  return (
    <div className="flex gap-2 items-start">
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-xs font-semibold">Prompt {index + 1}</span>
          {saveState === "saving" && (
            <Loader2 className="size-3.5 animate-spin text-muted-foreground" />
          )}
          {showCheck && <Check className="size-4 text-green-600" />}
        </div>
        <Textarea
          placeholder="Enter a question or task"
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          maxLength={300}
          className={cn("min-h-[4.5rem]")}
        />
      </div>
      <Button
        variant="ghost"
        size="icon"
        className="mt-7 size-8"
        onClick={onDelete}
        disabled={disabled}
      >
        <Trash2 className="size-4" />
      </Button>
    </div>
  );
};

export default SamplePromptRow;
